export function isToday(t) {
  const now = new Date()
  const date = new Date(t)
  return (
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate()
  )
}

export function rem2px(rem) {
  const width = process.client
    ? Math.min(document.documentElement.clientWidth, 750)
    : 750
  const e = width / 7.5
  return rem * e
}
